var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientscx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "180px",
    height: "100px",
    viewBox: "0 0 180 100",
    enableBackground: "new 0 0 180 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD41",
    d: "M46.114,59.031l-7.323-7.323l6.116-6.115c1.585-1.586,1.672-4.069,0.192-5.548 c-1.479-1.479-3.962-1.394-5.548,0.193l-6.115,6.115l-6.115-6.115c-1.585-1.586-4.069-1.671-5.549-0.193 c-1.478,1.479-1.392,3.962,0.193,5.548l6.116,6.115l-7.323,7.323c-1.586,1.585-1.671,4.069-0.193,5.548 c1.479,1.479,3.963,1.395,5.549-0.193l7.323-7.322l7.323,7.322c1.585,1.588,4.069,1.673,5.548,0.193 C47.786,63.101,47.7,60.616,46.114,59.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M180.028,51.482c0-5.239-3.393-9.271-8.834-9.271c-4.938,0-9.037,3.763-9.037,9.304 c0,5.343,3.762,9.271,9.171,9.271c3.427,0,6.853-1.478,8.129-5.441l-4.367-1.007c-0.671,1.478-2.218,2.115-3.828,2.115 c-2.318,0-4.031-1.411-4.063-3.729h12.83V51.482z M167.23,49.467c0.234-1.58,1.68-3.192,3.964-3.192 c2.082,0,3.661,1.412,3.896,3.192H167.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M101.827,60.227h3.865v-4.398h-3.394c-0.807,0-1.108-0.337-1.108-1.108v-7.861h4.703v-4.333h-4.703v-4.837 h-4.568v4.837h-3.259v4.333h2.922v7.896C96.285,58.615,98.268,60.227,101.827,60.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M125.576,60.227h3.863v-4.398h-3.394c-0.805,0-1.108-0.337-1.108-1.108v-7.861h4.702v-4.333h-4.702v-4.837 h-4.568v4.837h-3.259v4.333h2.924v7.896C120.034,58.615,122.017,60.227,125.576,60.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M156.949,60.227h3.862v-4.398h-3.393c-0.806,0-1.107-0.337-1.107-1.108v-7.861h4.701v-4.333h-4.701v-4.837 h-4.568v4.837h-3.259v4.333h2.922v7.896C151.406,58.615,153.39,60.227,156.949,60.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M60.379,60.227h4.904V49.949c0-1.781,1.243-3.125,3.023-3.125c1.713,0,2.922,1.311,2.922,3.09v10.312h4.904 V48.336c0-3.458-2.486-6.248-6.214-6.248c-2.05,0-3.494,0.907-4.299,2.049h-0.336v-1.612h-4.904V60.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M147.183,42.627h-4.904v10.054c0,1.742-1.242,3.058-3.023,3.058c-1.713,0-2.921-1.281-2.921-3.022V42.627 h-4.904v11.634c0,3.383,2.484,6.112,6.213,6.112c2.05,0,3.493-0.889,4.3-2.005h0.336v1.576h4.904V42.627z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M112.615,40.174c1.646,0,2.889-1.243,2.889-2.855c0-1.578-1.242-2.822-2.889-2.822 c-1.68,0-2.923,1.244-2.923,2.822C109.692,38.931,110.936,40.174,112.615,40.174z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "110.096,60.227 114.967,60.227 114.967,42.525 107.174,42.525 107.174,46.858 110.096,46.858  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M54.683,40.174c1.646,0,2.888-1.243,2.888-2.855c0-1.578-1.242-2.822-2.888-2.822 c-1.68,0-2.922,1.244-2.922,2.822C51.76,38.931,53.002,40.174,54.683,40.174z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "52.164,60.227 57.034,60.227 57.034,42.525 49.24,42.525 49.24,46.858 52.164,46.858  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M9.232,60.665c4.3,0,7.793-2.25,8.902-6.649l-4.569-1.11c-0.537,1.948-2.116,3.091-4.198,3.091 C6.713,55.996,5,53.98,5,51.394c0-2.62,1.68-4.635,4.368-4.635c2.083,0,3.695,1.176,4.232,3.191l4.535-1.143 c-1.143-4.434-4.603-6.718-8.902-6.718c-5.576,0-9.204,4.132-9.204,9.305C0.028,56.5,3.656,60.665,9.232,60.665z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M77.594,55.489l4.413-0.769c0.154,1.372,0.866,2.164,2.242,2.345c1.458,0.191,3.235,0.198,3.471-1.597 c0.351-2.673-2.869-2.533-4.739-2.797c-1.821-0.271-3.636-0.972-4.283-2.865c-0.778-2.27,0.002-5.06,1.993-6.437 c1.958-1.353,4.782-1.347,7.051-0.972c2.289,0.379,3.456,2.153,4.313,4.165c-1.26,0.44-2.52,0.879-3.779,1.319 c-0.386-0.528-0.439-1.085-1.042-1.486c-1.229-0.821-3.382-0.911-4.194,0.522c-1.314,2.316,2.783,2.469,4.093,2.729 c1.865,0.456,3.911,1.041,4.755,2.964c1.085,2.477,0.019,5.549-2.242,6.936c-2.193,1.348-5.307,1.452-7.755,0.828 C79.463,59.758,78.337,57.721,77.594,55.489"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientscx);
export default __webpack_public_path__ + "static/media/clientscx.b7140660ce640315fbfc88ab2097b385.svg";
export { ForwardRef as ReactComponent };